import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import SalesCatering from "../../assets/img/Featured/laptop-catering.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
const StudentCenterPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash studentCenterPage">
            <div className="background" />
            <Header />
            <div className="page-header">Student Center / Ballroom</div>
            <div className="text-blocks">
                <div className="std-text">
                    Make every meeting, social event, ceremony or 
                    fundraiser unforgettable with Agilysys Sales & 
                    Catering. With convenient event booking, menu 
                    selection and comprehensive logistics 
                    management, attendees will be guaranteed a truly 
                    memorable experience.{'\n\n'}
                </div>
                <div className="std-text">
                    And increase event revenue with yield 
                    management insights for group sales, conference 
                    and banqueting.
                </div>
            </div>
            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Conference & Ballroom Page", "Sales & Catering");
                    addFlow("Sales & Catering");
                    navigate("/solutions/sales")}}>
                    <img src={SalesCatering} alt="" />
                    <div className="item-head">
                        <LogoMini />
                        Sales & Catering
                    </div>
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default StudentCenterPage;